import cx from 'classnames';

import { iconMap } from './iconMap';
import { IconNames } from './IconNames';
import { Colors } from '../../constants/Colors';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconNames;
  color?: Colors;
  className?: string;
}

export const Icon: React.FC<IconProps> = (props) => {
  const { name, color = 'Inherit', className, ...rest } = props;
  const SvgComponent = iconMap[name];

  return (
    <SvgComponent className={cx('icon', `icon-${name}`, color, className)} {...rest} />
  );
};
